export default __webpack_public_path__ + "static/grass-d841edfb6680fcac6767832b5d265b96.svg";